﻿import Vue from "vue";
import Component from "vue-class-component";
import common from "../../../common";
import HotEditableFormManager_ from "./HotEditableFormManager";
import AjaxService_ from "../../../services/AjaxService";
import utilities_ from "../../utilities";
import core from "../../../core";
import context_ from "../../context";

const utilities = require("../../utilities") as typeof utilities_;
const context = require("../../context") as typeof context_;
// const HotEditableFormManager = require("./HotEditableFormManager") as HotEditableFormManager_;
// const AjaxService = require("../../../services/AjaxService") as AjaxService_;
// const FormNode = require("./FormNode") as FormNode_;

declare function __getHotEmbeddedFormComponentTemplate(): string;

@Component({
    props: {
        initId: String,
        initName: String,
        initValue: String,
        initIsVisible: Boolean,
        initCategory: String,
        initCssClass: String,
        initDisabled: String,
        initEditModeOn: Boolean,
        initDefaultUrl: String,
        initNavigationContextId: String,
        initLockScreenOnChange: Boolean
        // initCanChangeEditMode: Boolean,
        // initIsEmpty: Boolean,
        // initTabIndex: Number
    }
})
class HotEmbeddedFormComponent extends Vue implements common.IHotEditableEmbeddedComponent {

    initId?: string;
    initName?: string;
    initValue?: string;
    initIsVisible?: boolean;
    initCategory?: string;
    initCssClass?: string;
    initEditModeOn?: boolean;
    initDefaultUrl?: string;
    initNavigationContextId?: string;
    initLockScreenOnChange?: boolean;
    // initCanChangeEditMode?:  boolean;
    // initIsEmpty?:  boolean;
    // initTabIndex?:  number;

    rootId?: string;
    editModeOn?: boolean;
    elementValue?: string;
    cssClass?: string;
    category?: string;
    isVisible?: boolean;
    elementName?: string;
    idElement?: string;
    hasError?: boolean;
    fieldType = common.HotEditableFieldTypes.embeddedForm;
    defaultUrl?: string;
    navigationContextId?: string;
    lockScreenOnChange?: boolean;
    lockedScreen?: boolean;
    //formNode?:  FormNode;
    // canChangeEditMode?:  boolean;
    // isEmpty?:  boolean;
    // tabIndex?:  number;

    _ajaxService?: AjaxService_;
    _formManager?: HotEditableFormManager_ | null;//NOTE?:  Doit undefined initialement car il est definie dans le "beforeCreate"
    _innerWebComponent?: common.IWebComponent | null;
    _url?: string | null;

    static tagName = "hotembeddedform";

    data() {
        const guid = utilities.createGuid('N');
        const id = this.initId || "Field_" + guid;

        const o = {
            rootId: "HotEditableField_" + guid,
            idElement: id,
            elementName: this.initName || id,
            editModeOn: this.initEditModeOn === true,
            elementValue: this.initValue || '',
            cssClass: this.initCssClass || '',
            category: this.initCategory || '',
            isVisible: this.initIsVisible === true,
            defaultUrl: this.initDefaultUrl || '',
            lockScreenOnChange: this.initLockScreenOnChange === true,
            lockedScreen: false,
            navigationContextId: this.initNavigationContextId || (() => { throw "L'attribut 'init-navigation-context' est obligatoire."; })(),
            hasError: false
            // canChangeEditMode: this.initCanChangeEditMode === true,
            // isEmpty: this.initIsEmpty === true,
            // tabIndex: this.initTabIndex
        };
        return o;
    }

    setFromTextualValue(textualValue?: string) {
        textualValue = textualValue || '';

        if (this.elementValue !== textualValue)
            this.elementValue = textualValue;

        return this;
    }

    getTextualValue() {
        return this.elementValue || '';
    }

    created() { }

    mounted() {
        (this.$el as Element).removeAttribute("hot-editable-cloak");

        this._innerWebComponent = null;
        this._url = this.defaultUrl;
        this._ajaxService = new AjaxService_();

        if (this.elementValue)
            this.initializeContent();
        else
            this.restore();

        //this.updatePreviousValue();

        // permet de faire fonctionner le blur
        // document.addEventListener("mousedown", e => {
        //     if (!this.canChangeEditMode || !this.editModeOn)
        //         return;
        //     const root = this.$refs["root"] as Element;

        //     if (utilities.isOutsideElement(e.target as Element, root))
        //         this.onBlur(e);
        // });
    }

    beforeDestroy() {
        if (this._innerWebComponent) {
            if (this._innerWebComponent.destroy)
                this._innerWebComponent.destroy();
            this._innerWebComponent = null;
        }
    }

    private getNode() {
        return this._formManager?.formNode;
    }

    private initializeContent(finalCallback?: () => void) {
        // 'this' est la champ dans lequel est chargee le embeddedComponent (field > editVue > formManager)  
        const parentNode = this.getNode();
        const indent = "      ";
        HotEditableFormManager_.buildEchoDebug(() => indent + "[formName: " + this.elementName + "] Initialization started...");
        this.$nextTick(() => {
            /** Sera un DefaultEdit ou equivalent */
            const innerWebComponent = utilities.executeFirstScript(this.elementValue, null, null, finalCallback) as common.IWebComponent;
            if (innerWebComponent) {
                if (innerWebComponent.registerFormManagerParentNode)
                    innerWebComponent.registerFormManagerParentNode(parentNode, this.elementName, this._url);
                if (innerWebComponent.insertNavContextHiddenField)
                    innerWebComponent.insertNavContextHiddenField(this.navigationContextId);

            }
            HotEditableFormManager_.buildEchoDebug(() => indent + "[formName: " + this.elementName + "] Widget initialized successfully!");
            this._innerWebComponent = innerWebComponent;
        });
    }
    isDefaultUrlLoadded() {
        const getUrl = (x?: string | null) => utilities.updateUrlParameter((x ?? '').trim().toLowerCase(), context.url.parameters.navigationContext, '');
        const a = getUrl(this._url);
        const b = getUrl(this.defaultUrl);
        return a === b;
    }
    hasEmbeddedContents() { return this._formManager?.hasEmbeddedContents(); }
    hasEmbeddedContent(componentName: string) { return this._formManager?.hasEmbeddedContent(componentName); }
    unlockScreen(forceLock?: boolean) { return this.lockScreen(forceLock, false); }
    /** Default 'value' is TRUE. */
    lockScreen(forceLock?: boolean, value?: boolean) {
        value = value !== false;//==default=TRUE
        if (this.lockScreenOnChange || forceLock === true)
            this.lockedScreen = value;
    }
    /** Rechargera les widgets freres avec le dernier url. */
    refreshBrotherEmbeddedComponents() {
        const brothers = this.getHotEmbeddedBrotherComponents();
        if (brothers)
            for (let i = 0; i < brothers.length; i++)
                brothers[i].refresh();
    }
    /** Rechargera les widgets freres avec l'url initiale (default). */
    restoreBrotherEmbeddedComponents() {
        const brothers = this.getHotEmbeddedBrotherComponents();
        if (brothers)
            for (let i = 0; i < brothers.length; i++)
                brothers[i].restore();
    }
    /** Rechargera les widgets freres avec l'url initiale (default) SI l'url courrant n'est pas l'url initiale (default). */
    ensureBrotherEmbeddedComponentsIsDefaultUrl() {
        const brothers = this.getHotEmbeddedBrotherComponents();
        if (brothers)
            for (let i = 0; i < brothers.length; i++) {
                const x = brothers[i];
                if (!x.isDefaultUrlLoadded())
                    x.restore();
            }
    }
    /** Rechargera le widget avec l'url initiale (default). */
    restore(urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        this.update(null, urlParameters, editModeOn, finalEvalCallback);
    }
    /** Rechargera le widget avec le dernier url utilise. */
    refresh(urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        this.update(this._url, urlParameters, editModeOn, finalEvalCallback);
    }
    /** Si 'nextUrl' est NULL, alors l'url sera celle definie par DEFAULT */
    update(nextUrl?: string | null, urlParameters?: any, editModeOn?: boolean, finalEvalCallback?: () => void) {
        const navContextIdParamName = context.url.parameters.navigationContext;

        var url = nextUrl || this.defaultUrl;
        if (url) {
            this.lockScreen();

            if (this._innerWebComponent) {
                if (this._innerWebComponent.destroy)
                    this._innerWebComponent.destroy();
                this._innerWebComponent = null;
            }

            urlParameters = urlParameters || {};
            if (!urlParameters[navContextIdParamName])
                urlParameters[navContextIdParamName] = this.navigationContextId;

            url = utilities.updateUrlParameters(url, urlParameters);

            const indent = "  >>> ";
            HotEditableFormManager_.buildEchoDebug(() => indent + "[formName: " + this.elementName + ", url: " + url + ", editModeOn: " + editModeOn + "]");

            this.fetchUrl(url, result => {
                this.elementValue = result;
                this.editModeOn = editModeOn === true;
                this.initializeContent(finalEvalCallback);
            }, errors => {
                if (!HotEditableFormManager_.tryBuildEchoDebug(() => {
                    var msg = "[HotEmbeddedFormComponent] Erreur lors du IWebComponent.update(...)";
                    errors?.forEach(x => msg += "\r\n" + core.Error.toText(x));
                    return msg;
                })) this._formManager?.triggerFormError(errors);

                if (finalEvalCallback)
                    finalEvalCallback();
            }, () => {
                this._url = url;
                this.unlockScreen();
            });
        } else HotEditableFormManager_.echoDebug("[erreur] Aucune URL par default", this);

        return this;
    }

    private getHotEmbeddedBrotherComponents() {
        const res = [] as common.IHotEditableEmbeddedComponent[];
        const all = this._formManager?.getFields();
        if (all)
            for (let i = 0; i < all.length; i++) {
                const f = all[i];
                if (f.fieldType === common.HotEditableFieldTypes.embeddedForm && f.elementName !== this.elementName)
                    res.push(f as common.IHotEditableEmbeddedComponent);
            }

        return res;
    }
    private fetchUrl(url: string, onSuccess: (result: string) => void, onError: (errors: common.IError[]) => void, onFinal: () => void) {
        const innerOnSuccess = (result: any) => {
            var isApplied = false;
            if (typeof result === 'string') {
                onSuccess(result as string);
                isApplied = true;
            }

            // else if OTHER_CASE_HERE

            if (isApplied)
                onFinal();
            return isApplied;
        };
        const innerOnError = (errors: common.IError[]) => {
            onError(errors);
            onFinal();
        };
        this._ajaxService?.get(url, null, true, result => {
            if (innerOnSuccess(result))
                return;
            var errors = null as common.IError[] | null;
            if ((result as common.IResponse).info &&
                (result as common.IResponse).info.hasError &&
                (result as common.IResponse).info.errors &&
                (result as common.IResponse).info.errors.length) {
                errors = (result as common.IResponse).info.errors;
            }
            else {
                errors = new core.Error("Une erreur est survenue lors de l'affichage du contenu.").toArray();
                console.error(result);
            }

            innerOnError(errors);
        }, errors => {
            innerOnError(errors);
        });
    }

    beforeCreate() {
        this._formManager = ((this.$parent as any).formManager as HotEditableFormManager_).registerField(this);
        this.$options.template = __getHotEmbeddedFormComponentTemplate();
    }

    // editClick(event?: Event | null, forcedMode?: boolean) {
    //     if (!this.canChangeEditMode)
    //         return;

    //     // this.updatePreviousValue();

    //     if (forcedMode === true || forcedMode === false) {
    //         this.editModeOn = forcedMode;
    //     } else {
    //         //toggle
    //         this.editModeOn = !this.editModeOn;
    //     }

    //     this._formManager.editModeChanged(this);

    //     //this.focus();
    // }

    // onChanged(event: Event) {
    //     this.preventDefault(event);
    //     this.changed();
    // }

    // onCancel(event: Event) {
    //     this.preventDefault(event);
    //     this.cancel();
    // }

    // onClear(event: Event) {
    //     this.preventDefault(event);
    //     //this.clear();
    // }

    // private preventDefault(e?: Event, bypassStopPropagation?: boolean) {
    //     if (!e)
    //         return;

    //     e.preventDefault();

    //     if (bypassStopPropagation !== true)
    //         e.stopPropagation();
    // }
    // clear() {
    //     // this.elementValue = "";
    //     // this.$nextTick(() => {
    //     //     this.changed();
    //     // });
    // }

    changed() {

        // if (this.canChangeEditMode) {
        //     this.editModeOn = false;
        //     this._formManager.editModeChanged(this);

        //     // if ((this.elementValue || '').trim() === this._previousValue)
        //     //     return;
        // }

        this._formManager?.fieldChanged(this);
    }

    // cancel() {
    //     if (!this.canChangeEditMode)
    //         return;

    //     // this.elementValue = this._previousValue;

    //     this.editModeOn = false;

    //     //NOTE: Le "blur()" va lancer le "changed()"
    //     //this.$root.$emit('hotEditableTextbox-editModeChanged', this);
    // }

    // blur() {
    //     this.changed();
    // }

    // focus() {
    //     this.$nextTick(() => {
    //         const instance = this.$refs["inputInst"] as HTMLInputElement;
    //         instance.focus();
    //     });
    // }

    // private focusNextComponent(getPrevious?: boolean) {
    //     getPrevious = getPrevious === true;

    //     if (!this.canChangeEditMode)
    //         return false;

    //     this.changed();
    //     this.editClick(null, false);

    //     if (getPrevious)
    //         this._formManager.focusPreviousComponentFromField(this)
    //     else
    //         this._formManager.focusNextComponentFromField(this);
    // }

    // updatePreviousValue(value?: any) {
    //     this._previousValue = value || value === '' || value === 0 || value === false ? (value as string).trim() : (this.elementValue || '').trim();
    //     return this;
    // }

    // onEnterClick(event?: KeyboardEvent) {
    //     if (event && this.canChangeEditMode) {
    //         event.preventDefault();
    //         event.stopPropagation();
    //     }

    //     this.changed();
    // }

    // onEscapeClick(event?: KeyboardEvent) {
    //     if (event && this.canChangeEditMode) {
    //         event.preventDefault();
    //         event.stopPropagation();
    //     }

    //     this.cancel();
    // }

    // onTabClick(event?: KeyboardEvent) {
    //     //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
    //     if (event.shiftKey) {
    //         this.onShiftTabClick(event);
    //         return;
    //     }

    //     this.focusNextComponent();

    //     if (event && this.canChangeEditMode) {
    //         event.preventDefault();
    //         event.stopPropagation();
    //     }
    // }

    // onShiftTabClick(event?: KeyboardEvent) {
    //     //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
    //     this.focusNextComponent(true);

    //     if (event && this.canChangeEditMode) {
    //         event.preventDefault();
    //         event.stopPropagation();
    //     }
    // }
}

export = HotEmbeddedFormComponent;